export default __webpack_public_path__ + "static/media/path-1.c1934fcb.png";